import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-fiches-de-poste-item-entreprise',
  templateUrl: './fiches-de-poste-item-entreprise.component.html',
  styleUrls: ['./fiches-de-poste-item-entreprise.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FichesDePosteItemEntrepriseComponent implements OnInit {
  @Input() fiche: any;
  constructor() {}

  ngOnInit(): void {}
}
